import React from "react";
import { createPortal } from "react-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { formatDrawCoin } from "../../utils/bondDrawHelpers";

const BondDrawResultModal = ({
  open = false,
  isWin = false,
  matches = 0,
  stake = 0,
  winAmount = 0,
  netWinAmount = null,
  selectedNumbers = [],
  drawnNumbers = [],
  matchedNumbers = [],
  onClose,
}) => {
  if (!open) return null;
  const tone = isWin ? "success" : "danger";

  return createPortal(
    <div className="bdraw-result-root" role="dialog" aria-modal="true" aria-labelledby="bdraw-result-title">
      <button type="button" className="bdraw-result-backdrop" aria-label="Close" onClick={onClose} />
      <div className={`bdraw-result-sheet tone-${tone}`}>
        <div className={`bdraw-result-icon ${isWin ? "success" : "danger"}`}>
          {isWin ? <CheckCircle2 size={28} strokeWidth={2.25} /> : <XCircle size={28} strokeWidth={2.25} />}
        </div>

        <h2 id="bdraw-result-title" className="bdraw-result-title">
          {isWin ? "You won!" : "No match"}
        </h2>
        <p className="bdraw-result-subtitle">
          {matches} of {drawnNumbers.length} drawn numbers matched
        </p>

        <div className="bdraw-result-info">
          <div className="bdraw-result-row">
            <span>Your picks</span>
            <span className="bdraw-result-balls">
              {(selectedNumbers || []).map((n) => (
                <span
                  key={`s-${n}`}
                  className={`bdraw-ball s${matchedNumbers.includes(n) ? " match" : ""}`}
                >
                  {n}
                </span>
              ))}
            </span>
          </div>
          <div className="bdraw-result-row">
            <span>Drawn</span>
            <span className="bdraw-result-balls">
              {(drawnNumbers || []).map((n) => (
                <span
                  key={`d-${n}`}
                  className={`bdraw-ball d${matchedNumbers.includes(n) ? " match" : ""}`}
                >
                  {n}
                </span>
              ))}
            </span>
          </div>
        </div>

        <div className={`bdraw-result-outcome ${isWin ? "win" : "loss"}`}>
          <span>{isWin ? "Net payout" : "Lost stake"}</span>
          <strong>
            COIN {isWin
              ? formatDrawCoin(netWinAmount != null ? netWinAmount : winAmount)
              : `-${formatDrawCoin(stake)}`}
          </strong>
          {isWin && netWinAmount != null && winAmount !== netWinAmount ? (
            <small>Gross {formatDrawCoin(winAmount)} · 5% fee on profit</small>
          ) : null}
        </div>

        <button type="button" className="bdraw-result-btn" onClick={onClose}>
          Continue
        </button>
      </div>
    </div>,
    document.body
  );
};

export default BondDrawResultModal;
